import { useMonth } from "@datepicker-react/hooks";
import { Box, IconButton, Typography, useTheme } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Maybe } from "../../models/common/generic-types";
import { firstLetterUppercase } from "../../utils/first-letter-uppercase";
import Day from "./Day";

interface MonthProps {
	year: number;
	month: number;
	startDate?: Maybe<Date>;
	endDate?: Maybe<Date>;
	index: number;
	goToPreviousMonths: () => void;
	goToNextMonths: () => void;
	handleSelectDay: (date: Date) => void;
}

const Month: React.FC<MonthProps> = ({ year, month, startDate, endDate, index, goToPreviousMonths, goToNextMonths, handleSelectDay }) => {
	const { spacing } = useTheme();
	const { t } = useTranslation();
	const { days, weekdayLabels, monthLabel } = useMonth({
		year,
		month,
		firstDayOfWeek: 1,
		monthLabelFormat: (date) => `${t(format(date, "MMMM").toLowerCase())} ${format(date, "yyyy")}`,
		dayLabelFormat: (date) => format(date, "d"),
		weekdayLabelFormat: (date) => firstLetterUppercase(t(format(date, "EEEEEE").toLowerCase()))!,
	});

	return (
		<Box>
			<Box display="flex" justifyContent="space-between">
				<IconButton onClick={goToPreviousMonths}>
					<ChevronLeft />
				</IconButton>
				<Typography
					color="textSecondary"
					style={{
						paddingTop: spacing(1.6),
						fontWeight: 600,
					}}
				>
					{monthLabel}
				</Typography>
				<IconButton onClick={goToNextMonths}>
					<ChevronRight />
				</IconButton>
			</Box>
			<Box
				display="grid"
				gridTemplateColumns="repeat(7, 1fr)"
				justifyContent="center"
				marginBottom={spacing(0.1)}
				marginTop={spacing(0.3)}
			>
				{weekdayLabels.map((dayLabel) => (
					<Typography color="textSecondary" align="center" variant="caption" key={dayLabel}>
						{dayLabel}
					</Typography>
				))}
			</Box>
			<Box display="grid" gridTemplateColumns="repeat(7, 1fr)" justifyContent="center">
				{days.map((day, index) => {
					if (typeof day === "object") {
						return (
							<Box key={day.date.getTime()} bgcolor={"white"}>
								<Day
									date={day.date}
									dayLabel={day.dayLabel}
									startDate={startDate}
									endDate={endDate}
									handleSelectDay={handleSelectDay}
								/>
							</Box>
						);
					}

					return <Box key={index} />;
				})}
			</Box>
		</Box>
	);
};

export default Month;
